import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { getUploadLogs } from 'actions/uploadlogs'
import BackToAdminCentre from 'components/BackToAdminCentre'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { Container } from 'components/layout/Grid/'
import constants from 'constants'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { hasAccess } from 'utils/hasAccess'

class UploadLogsCapitalLoans extends Component {
  static propTypes = {
    routes: PropTypes.array.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
    getUploadLogs: PropTypes.func.isRequired,
    uploadLogs: PropTypes.object.isRequired,
  }
  componentDidMount() {
    const currentUser = this.props.currentUser
    const access = hasAccess(this.props.currentUser, 'Tax Statements', this.props.history)
    if (access) {
      this.props.getUploadLogs('CapitalLoansUploadLogs', constants.UPLOADLOGS.CAPITALLOANS_FOLDER.TRUSTDEEDS)
      this.props.getUploadLogs('CapitalLoansUploadLogs', constants.UPLOADLOGS.CAPITALLOANS_FOLDER.LOANPACK)
      this.props.getUploadLogs('CapitalLoansUploadLogs', constants.UPLOADLOGS.CAPITALLOANS_FOLDER.AMOUNTCONFIRMATION)
    }
  }

  render() {
    const { routes, currentUser } = this.props
    const backToAdminCentreText = 'Capital loans documents upload status'
    return (
      <div><BackToAdminCentre displayText={backToAdminCentreText} isAdmin={this.props.currentUser.IsAdmin} /><Container>
        {routes.map((route, i) => (
          <RouteWithSubRoutes
            key={i}
            {...route}
            backToAdminCentreText={backToAdminCentreText}
            currentUser={currentUser}
            getUploadLogs={this.props.getUploadLogs}
            setErrorMessage={this.props.setErrorMessage}
            uploadLogs={this.props.uploadLogs}
          />
        ))}
      </Container></div>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  uploadLogs: state.uploadLogs,
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  getUploadLogs,
})(UploadLogsCapitalLoans))



// WEBPACK FOOTER //
// ./src/containers/UploadLogsCapitalLoans.js